import React from 'react';
import PropTypes from 'prop-types';

import { Button } from './MockErrorComponent.styles';
import {
  ShopifyErrorPage,
  FlexContent,
  DescriptionLabel,
  TopImage,
  TitleLabel,
} from '../../CommonError/CommonError.styles';

const MockErrorComponent = ({ setSelectedTask }) => {
  const exitAction = function () {
    setSelectedTask(null);
  };

  return (
    <ShopifyErrorPage className="text-center">
      <FlexContent>
        <div className="row">
          <div className="col-xs-12">
            <TopImage className="svg" alt="" src="/images/x-green.svg" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <TitleLabel>Something went wrong!</TitleLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <DescriptionLabel>An error occurred while performing your action, please try again.</DescriptionLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text-center">
            <Button onClick={exitAction}>BACK TO ACTIONS</Button>
          </div>
        </div>
      </FlexContent>
    </ShopifyErrorPage>
  );
};

MockErrorComponent.propTypes = {
  setSelectedTask: PropTypes.func.isRequired,
};

export default MockErrorComponent;
